<div class="page-header-container">
  <div class="d-flex flex-column">
    <div class="page-title">
      <button class="btn link-btn btn-back">
        <i class="app-icon icon icon-chevron-left icon-xxl" (click)="backHandler()"></i>
      </button>
      {{ "contractDetail.contract" | translate }}
      <span HJSuppress class="text-primary fw-bold">
        {{ contract?.number }}
      </span>
    </div>

    <div class="page-subtitle mb-2">
      @switch (contract?.dictionaryContractType?.code) {
        @case (ContractType.OPERATIONAL_LEASING) {
          <div HJSuppress>{{'contracts.contractType.operationalLeasing' | translate}}</div>
        }
        @case (ContractType.FINANCIAL_LEASING) {
          <div HJSuppress>{{'contracts.contractType.financialLeasing' | translate}}</div>
        }
        @case (ContractType.CREDIT) {
          <div HJSuppress>{{'contracts.contractType.credit' | translate}}</div>
        }
      }
    </div>

    <div class="page-subtitle-details d-flex align-items-center justify-content-center justify-content-lg-start gap-3">
      <div class="d-flex flex-column">
        <div class="page-subtitle-details-label text-secondary fw-semibold">
          {{ "contractDetail.startupDate" | translate }}
        </div>
  
        <div HJSuppress class="page-subtitle-details-value text-main fw-bold">
          {{ contract?.startDate | localizedDate }}
        </div>
      </div>
      <i class="app-icon icon icon-arrow-right icon-md"></i>  
      <div class="d-flex flex-column">
        <div class="page-subtitle-details-label text-secondary fw-semibold">
          {{ "contractDetail.endDate" | translate }}
        </div>
  
        <div HJSuppress class="page-subtitle-details-value text-main fw-bold">
          {{ contract?.endDate | localizedDate }}
        </div>
      </div>
    </div>    
  </div>

  <div class="header-buttons-box">
    <button *ngIf="contract?.isActive"
      class="btn outline-btn ms-auto"
      (click)="redirectNewRequestHandler()" >
      {{'requests.cards.addNewRequest' | translate}}
    </button>
  </div>
</div>

<div class="row">
  <div class="col-xxl-8">
    <div class="l-content-info-box d-flex justify-content-between align-items-center flex-column flex-md-row">
      <div *ngIf="contract?.dictionaryContractType.code !== ContractType.OPERATIONAL_LEASING" 
        class="l-content-info-subbox">
        @switch (contract?.dictionaryContractType.code) {
          @case (ContractType.FINANCIAL_LEASING) {
            <div class="l-subbox-title">
                {{('outstandingAmount.financialLeasing' | translate)}}
            </div>
          }
          @case (ContractType.CREDIT) {
            <div class="l-subbox-title">
                {{('outstandingAmount.credit' | translate)}}
            </div>
          }
        }
        <div HJSuppress class="l-subbox-value">
          {{ contract?.outstandingAmount | number: "1.2" }} {{ contract?.currency }}
        </div>

        <div class="l-subbox-description">
          <span HJSuppress class="l-subbox-description-highlighted">
            {{ contract?.totalLease | number: "1.2" }} {{ contract?.currency }}
          </span>
          {{ "contractDetail.totalLease" | translate }}
        </div>
      </div>

      <div *ngIf="contract?.dictionaryContractType.code === ContractType.OPERATIONAL_LEASING || contract?.dictionaryContractType.code === ContractType.CREDIT" class="l-content-info-subbox">
        <div class="l-subbox-title">
          {{ "contractDetail.nextInstallmentAmount" | translate }}
        </div>
        <div HJSuppress class="l-subbox-value">
          {{ contract?.nextPayment | number: "1.2" }} {{ contract?.currency }}
        </div>
      </div>

      <div class="l-content-info-subbox subbox-separator">
        <div class="l-subbox-title">
          {{ "contractDetail.installmentsLeft" | translate }}
        </div>

        <div HJSuppress class="l-subbox-value">
          {{ contract?.installmentsLeft }}
        </div>

        <div class="l-subbox-description">
          <span HJSuppress class="l-subbox-description-highlighted">
            {{ contract?.totalInstallments }} {{ "contractDetail.installments" | translate }}
          </span>
          {{ "contractDetail.inTotal" | translate }}
        </div>
      </div>

      <div *ngIf="contract?.dictionaryContractType.code === ContractType.FINANCIAL_LEASING" class="l-content-info-subbox subbox-separator">
        <div class="l-subbox-title">
          {{ "contractDetail.residualValue" | translate }}
        </div>

        <div HJSuppress class="l-subbox-value">
          {{ contract?.residualValue | number: "1.2" }} {{ contract?.currency }}
        </div>

        <div class="l-subbox-description"></div>
      </div>

      <div *ngIf="contract?.dictionaryContractType.code === ContractType.CREDIT" class="l-content-info-subbox subbox-separator">
        <div class="l-subbox-title">
          {{ "contractDetail.balloonPayment" | translate }}
        </div>

        <div HJSuppress class="l-subbox-value">
          {{ contract?.balloon | number: "1.2" }} {{ contract?.currency }}
        </div>

        <div class="l-subbox-description"></div>
      </div>
    </div>
  </div>

  <div class="col-xxl-4">
    <div class="mt-3 mt-xxl-0 l-content-info-box">
      <div class="l-content-info-subbox">
        <div class="l-subbox-title d-flex align-items-center">
          {{ "contractDetail.paymentAmounts" | translate }}
          <i class="app-icon icon icon-warning-circle info-tooltip-trigger ms-1"
            [ngbTooltip]="currentPaymentTooltip"
          ></i>
        </div>
          <div HJSuppress class="l-subbox-value">
            {{ contract?.paymentAmounts | number:"1.2" }}
            <ng-container *ngIf="contract?.paymentAmounts !== null">
                {{contract?.invoiceCurrency}}
            </ng-container>
            <ng-container *ngIf="contract?.paymentAmounts === null">
              {{ contract?.currency }}
          </ng-container>
          </div>
        <div class="l-subbox-description">
          <span *ngIf="contract?.nextPaymentDate">
            {{ "contractDetail.dueDate" | translate }}
          </span>
          <span HJSuppress class="l-subbox-description-highlighted">
            {{ contract?.nextPaymentDate | localizedDate }}
          </span>
        </div>
      </div>

      <div class="l-content-info-subbox">
        <button class="btn link-btn redirect-link-btn" (click)="invoicesHandler()">
          <span>{{ "contractDetail.goToInvoices" | translate }}</span>
          <i class="app-icon icon icon-arrow-right icon-md2 ms-2"></i>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="l-tabs">
  <nav class="d-flex flex-column flex-md-row"
    [style.--tab-count]="tabs.length">
    <ng-container *ngFor="let tab of tabs; let i = index">
      <label [for]="'tab' + tab.value"
        [ngClass]="{'active-tab-label' : currentSub === tab.value}"
        [style.anchor-name]="'--tab-anchor-' + i"
      > 
        <input type="radio"
          name="tab"
          [id]="'tab' + tab.value"
          class="d-none"
          [disabled]="currentSub === tab.value"
          (change)="switchHandler(tab.key)"
        />
        <a class="d-flex justify-content-center align-items-center text-main gap-3">
          <i [class]="'app-icon icon-xl icon ' + tab.iconName" ></i>
          <span>{{ tab.label | translate }}</span>
        </a>
      </label>
    </ng-container>

    <div class="active-tab-bg-animation bg-primary"
      [style.position-anchor]="'--tab-anchor-' + currentSub"
    ></div>
  </nav>
</div>

<contract-detail-assets *ngIf="currentSub === 0" 
  class="card contract-details-card mt-4" 
  [assets]="assets" 
  [props]="assetsProps"
  [contract]="contract"
  [requestAccessWarnings]="warningMessages">
</contract-detail-assets>

<contract-detail-payment-schedule *ngIf="currentSub === 1" 
  class="card contract-details-card mt-4" 
  [contract]="contract"
  [paymentSchedules]="paymentSchedules" 
  [props]="paymentSchedulesProps" 
  [contractId]="contractId">
</contract-detail-payment-schedule>

<contract-detail-collaterals *ngIf="currentSub === 2" 
  class="card contract-details-card mt-4" 
  [collaterals]="collaterals"
  [props]="collateralsProps">
</contract-detail-collaterals>

<contract-detail-insurances *ngIf="currentSub === 3" 
  class="card contract-details-card mt-4" 
  [insurances]="insurances"
  [props]="insurancesProps"
  [contractType]="contract?.dictionaryContractType.code">
</contract-detail-insurances>

<ng-template #currentPaymentTooltip>
  {{ "contractDetail.nextPaymentInfo" | translate }}
</ng-template>
